module.exports = __webpack_public_path__ + "img/808fe4e2b8a803ac20b92ec43cfc792.8eb055f3.png";